
<template>
<div class="content">

      <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
        <router-link :to="{ path: '/directors'}">
          <button type="submit" class="btn btn-danger active btn-sm  px-2 mr-2">Yönetim Kurulu</button>
        </router-link>
        <router-link :to="{ path: '/staffs'}">
          <button type="submit" class="btn btn-info btn-sm mr-2 px-2">Federasyon Personeli</button>
        </router-link>
        <router-link :to="{ path: '/all-leaders'}">
          <button type="submit" class="btn btn-primary btn-sm mr-2 px-2">Başkanlarımız</button>
        </router-link>
        <router-link :to="{ path: '/history'}">
          <button type="submit" class="btn btn-success btn-sm mr-2 px-2">Tarihçe</button>
        </router-link>
        <router-link :to="{ path: '/sub-board-categories'}">
          <button type="submit" class="btn btn-warning btn-sm mr-2 px-2">Alt Kurullar</button>
        </router-link>
        <router-link :to="{ path: '/provincial-offices'}">
          <button type="submit" class="btn btn-secondary btn-sm  mr-2 px-2">İl Temsilcilikleri</button>
        </router-link>
        <router-link :to="{ path: '/bank-informations'}">
          <button type="submit" class="btn btn-success btn-sm  mr-2 px-2">Hesap Numaraları</button>
        </router-link>
        <router-link :to="{ path: '/main-status-instructions'}">
          <button type="submit" class="btn btn-info btn-sm mr-2 px-2">Ana Statü Talimatlar</button>
        </router-link>
      </div>
      <span></span>
    </div>
  <card>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div v-if="!err">
           <small>Resim Boyutu 400x450px </small>
            <h4 class="d-flex justify-content-between mt-0">


              <span>Yönetim Kurulu 
                <small class="small text-primary">(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)</small>
                </span>

                <div class="d-flex">
                 <button class="mr-2 btn btn-danger btn-sm btn-fill" v-on:click="addNew()">
                  Ekle
                </button>
             <button class="btn btn-primary btn-sm btn-fill" v-on:click="update()">Kaydet</button>
             </div>
             </h4>
            <draggable v-model="slider" :options="{animation:200}" @update="update()">
              <transition-group>
                <div v-for="(item, index) in slider" :key="index+1">
                  <div class="card mb-2 menu-item">
                    <div class="card-body row">
                      <div class="col-2">
                        <img class="img-fluid" :src="mediaURL() + item.image">
                      </div>
                      <div class="col-9 d-flex align-items-center">
                        <div class="row w-100">
                          <div class="col-12 col-md-6">
                            <label>Ad Soyad</label>
                            <input type="text" name="" v-model="item.title" class="form-control">
                          </div>
                          <div class="col-12 col-md-6">
                            <label>Görevi</label>
                            <input type="text" name="" v-model="item.target_url" class="form-control">
                          </div>
                          <!-- <div class="col-12">
                            <label>Kısa Açıklama</label>
                            <input type="text" name="" v-model="item.description" class="form-control">
                          </div> -->
                        </div>
                      </div>
                      <div class="col-1 d-flex justify-content-end align-items-center">
                        <div class="d-flex flex-column"> 
                          <button v-b-modal.croppieModal v-on:click="initiateCroppie(item.id,index,0)" v-b-tooltip title="Slider Resmini Değiştir" class="btn btn btn-sm "><i class="fas fa-image fa-fw"></i></button>
                            <button v-on:click="remove(item.id)" class="btn btn-danger btn-sm mt-1">
                            <i class="fas fa-times fa-fw"></i>
                          </button>
                                                  </div>

                        <img v-bind:src="newSliderImage.cropped" class="img-fluid mt-4 border border-secondary p-2 d-none">
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
</div>
<div v-if="err">
{{err}}
</div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="croppieModal" hide-footer size="lg" title="Resim Seç">
      <input name="myFile" id="myImage" class="m-3" type="file" @change="bind()">
      <vue-croppie :enable-resize="false" :viewport="{width: 360, height: 405, type: 'suare'}" :boundary="{width: 400, height: 450}" ref=main :enableOrientation="true" @result="result">
      </vue-croppie>
      <b-btn class="mt-3" variant="danger btn-fill" @click="hideCroppieModal()">İptal</b-btn>
      <b-btn class="mt-3" id="submit-image" variant="success btn-fill float-right" @click="changeButtonText()">Kaydet</b-btn>
    </b-modal>
  </card>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import { ModelSelect } from 'vue-search-select'

  export default {
    data: function () {
      return {
        slider:[{
          image:null,
          title:null,
          description: null,
          target_url:null,
          image_type:'directors',
          order_number:null
        }],
        err:null,
        selectedType: null,
        types : ['URL','Kategori','Alt Kategori','Yayın','Etiket'],
        options: [],
        sliderItems: null,
        newSliderImage:{
          cropped:null,
          image_id:null,
          image_name:null,
          imageIndex:null
        },
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'all',
        viewCounts: []
      }
    },
    components: {
      Card,
      ModelSelect
    },

    methods: {
            remove: function (id) {
              if(confirm("Silmek İstediğinize eminmisiniz?")){
        this.$http.delete("/api/images/delete/" + id).then(
          response => {
             this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi')
            this.getSlider();
          },
          e => {
            if(!e.body.Error){
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            }else{
            this.notifier("top", "right", "danger", e.body.Error);
            }
          }
        );
      }},
      uploadImage: function(){

        this.$http.post('/api/images/upload/' + this.newSliderImage.image_name + 'directors-slider', this.newSliderImage).then(
          response => {
             var i = this.newSliderImage.n === 0 ? 'image' : 'image2';
            this.slider[this.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
            this.toggleLoader()
            this.hideCroppieModal()
            this.update()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      addNew: function () {
        this.slider.push({
          image: null,
          title: null,
          description: null,
          target_url: null,
          image_type: 'directors',
          order_number: null
        });
      },
      update: function(){
         this.slider.forEach(function (s) {
          if (!s.image) s.image = s.image2
          s.image_type = 'directors';
        });
        this.$http.post('/api/images/edit/', this.slider).then(
          response => {
            this.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi')
            this.getSlider()
          },
          e => {
            if(!e.body.Error){
              
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
          })
      },
      getSlider: function () {
        var url = '/api/images/directors'
        this.$http
        .get(url)
        .then(
          response => {
             this.slider = response.body
             this.err = null;

          },
          er => {
            if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }

          })
      },
      initiateCroppie: function(id,i, n){
        this.newSliderImage.image_id = id
        this.newSliderImage.image_name = this.slugify(this.slider[i].title)
        this.newSliderImage.imageIndex = i
        this.newSliderImage.n = n;
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      },
      bind() {
        var oFReader = new FileReader();
        if(document.getElementById("myImage").files.length){
          oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
          var refz = this.$refs
          oFReader.onload = function (oFREvent) {
            refz.main.bind({
              url: oFREvent.target.result
            })
          };   
        }
        
      },
      changeButtonText: function(){
        
        this.crop()
      },
      crop () {
        var dis = this;
        this.toggleLoader()
        return new Promise(resolve => {
          let options = {
            format: 'jpeg'|'png'|'webp',
            backgroundColor: '#fff',
            size: {
              width: 400,
              height: 450
            },
            quality: 1
          };
          dis.$refs.main.result(options, (output) => {
            this.newSliderImage.cropped = output
            this.uploadImage()
            dis.$refs.main.refresh()
            resolve(output)
          })
        })
      },
      hideCroppieModal(){
        this.$root.$emit('bv::hide::modal','croppieModal')
      },
      result(output) {
        return output
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getSlider()
      })
    }
  }
</script>
<style>
div#croppieModal {
    display: flex!important;
    align-items: center;
    justify-content: center;
    height: 100%!important;
}

div#croppieModal .modal-dialog {
    transform: none!important;
}
.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  background-color: #007bff !important;
}
.nav-pills:focus{
  outline: none;
}
.nav-pills a{
  color:#000;
}

.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  color:#fff;
}
.nav-item{
  margin-bottom: 5px;
}
.menu-item:hover{
  cursor: move;
}

.bg-gray{
  background-color: #bdc3c7 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DirectorsModules/Index.vue